const splitProductToken = (productToken: string) => {
  const [slug, ean] = productToken.split('--');

  return { slug, ean };
};

export default splitProductToken;
